/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignFinalPackageStatus = {
    Pending: 'pending',
    Ready: 'ready',
    Failed: 'failed',
} as const;
export type EsignFinalPackageStatus = typeof EsignFinalPackageStatus[keyof typeof EsignFinalPackageStatus];


export function instanceOfEsignFinalPackageStatus(value: any): boolean {
    for (const key in EsignFinalPackageStatus) {
        if (Object.prototype.hasOwnProperty.call(EsignFinalPackageStatus, key)) {
            if (EsignFinalPackageStatus[key as keyof typeof EsignFinalPackageStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignFinalPackageStatusFromJSON(json: any): EsignFinalPackageStatus {
    return EsignFinalPackageStatusFromJSONTyped(json, false);
}

export function EsignFinalPackageStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignFinalPackageStatus {
    return json as EsignFinalPackageStatus;
}

export function EsignFinalPackageStatusToJSON(value?: EsignFinalPackageStatus | null): any {
    return value as any;
}

export function EsignFinalPackageStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignFinalPackageStatus {
    return value as EsignFinalPackageStatus;
}

